import { render, staticRenderFns } from "./product-detail-dialog.vue?vue&type=template&id=4983b432&scoped=true"
import script from "./product-detail-dialog.ts?vue&type=script&lang=ts&external"
export * from "./product-detail-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./product-detail-dialog.scoped.scss?vue&type=style&index=0&id=4983b432&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983b432",
  null
  
)

export default component.exports